<script lang="ts">
  import ProgressBar from "../components/ProgressBar.svelte";
  import Timer from "../components/Timer.svelte";

  export let SymetricalElements = 1;
  export let activeElements = 1;
</script>

<div class="header-wrapper">
  <Timer {SymetricalElements} {activeElements} />
  <div class="bar-container">
    <h5>prog</h5>
    <ProgressBar {SymetricalElements} {activeElements} />
  </div>
</div>

<style>
  .header-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    box-shadow: 1px -7px 11px 0px rgba(0, 0, 0, 0.75);
    height: 40px;
    background-color: #75c9b7;
    border: 3px solid white;
    border-top: none;
    color: black;
    box-sizing: border-box;
    padding: 0 5px;
  }
  .bar-container {
    display: flex;
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
  }
</style>
